import React, { ChangeEvent, ReactNode, useEffect, useRef } from 'react'

import { adjustLabelForOptionality } from './Option'
import { ProductOptionWithNameProps } from '../../../../../shared/js/Module'

const Radios = ({
  details,
  disabled,
  id,
  label,
  name,
  onChange,
  onFontChange,
  required,
  triggerFocus,
  values,
  valid,
}: ProductOptionWithNameProps) => {
  const selectedValueId = values.find(({ selected }) => selected)?.id
  const descriptionId = details ? `description-input-${id}` : null
  const ariaDescribedBy = descriptionId
    ? { 'aria-describedby': descriptionId }
    : {}
  const fieldRef = useRef<HTMLInputElement>(null)

  let finalLabel: ReactNode = label
  if (!required) {
    finalLabel = adjustLabelForOptionality(label)
  }

  // When autofocus is expected, trigger it,
  // then move smoothly into view
  useEffect(() => {
    if (fieldRef.current && triggerFocus) {
      fieldRef.current.scrollIntoView({ behavior: 'smooth' })
      fieldRef.current.focus({ preventScroll: true })
    }
  }, [triggerFocus])

  return (
    <>
      <legend>{finalLabel}</legend>
      {values.map(
        ({ id: valueId, imgURL, imgKind, label: valueLabel, cents }) => (
          <React.Fragment key={valueId}>
            <input
              defaultChecked={selectedValueId === valueId}
              disabled={disabled}
              id={`radio-${valueId}`}
              name={name}
              onChange={handleChange}
              ref={fieldRef}
              type='radio'
              value={valueId}
              {...ariaDescribedBy}
            />
            <label
              className={
                'c-label c-label--image' +
                (imgKind ? ` c-label--image-${imgKind}` : '')
              }
              htmlFor={`radio-${valueId}`}
            >
              {imgURL && (
                <img
                  src={imgURL}
                  className={`c-label__${imgKind}`}
                  alt={`Prévisualisation de ${valueLabel}`}
                />
              )}
              {valueLabel}
            </label>
          </React.Fragment>
        )
      )}

      {!valid && (
        <p className='c-message c-message--error'>
          Vous devez choisir une option
        </p>
      )}
      {descriptionId && (
        <p id={descriptionId} className='c-message c-message--help'>
          {details}
        </p>
      )}
    </>
  )

  function handleChange({
    target: { value: selectedId },
  }: ChangeEvent<HTMLInputElement>) {
    let selectedFontClassName = null
    const updatedValues = values.map((value) => {
      const selected = value.id === Number(selectedId)
      if (selected) {
        selectedFontClassName = value.fontClassName
      }
      return { ...value, selected }
    })
    onChange?.(id, updatedValues)
    onFontChange?.(selectedFontClassName)
  }
}

export default Radios
